export default __webpack_public_path__ + "static/media/smappComplete.4e54d6c1.png";